import React from "react";
import { useState } from "react";
import "../scss/_slide.scss";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { RiWechatLine } from "@remixicon/react";
import { RiMacLine } from "@remixicon/react";
import { RiCalendarTodoFill } from "@remixicon/react";
import { RiCommunityFill } from "@remixicon/react";

function ResearchList({ isActive, handleDataClick }) {
    const { i18n } = useTranslation();
    const researchData = i18n.getResourceBundle(
        i18n.language,
        "researchTranslationContainer"
    ).researchTranslation;

    return (
        <>
            <div className="researchListContainer">
                {researchData.map((data, i) => (
                    <button
                        className="buttonContainer"
                        key={i}
                        onClick={() => handleDataClick(i)}
                    >
                        <motion.div
                            className={`listContainer ${isActive === i ? "active" : ""}`}
                            whileHover={{
                                scale: 1.05,
                            }}
                            transition={{
                                duration: 0.8,
                                delay: 0.1,
                                ease: [0, 0.71, 0.2, 1.01],
                            }}
                        >
                            <div className="title">{data.title}</div>
                            <div className="content">{data.content}</div>
                        </motion.div>
                    </button>
                ))}
            </div>
        </>
    );
}

function ResearchText({ isActive, handleDataClick }) {
    const { t } = useTranslation();
    const { i18n } = useTranslation("researchTranslationContainer");
    const researchData = i18n.getResourceBundle(
        i18n.language,
        "researchTranslationContainer"
    ).researchTranslation;

    return (
        <>
            <div className="textContainer">
                <div className="bigTitle">{t("AdvantagesOfResearchDataTitle")}</div>
                <div className="dataList">
                    <div className="carousel-dots">
                        <div className="line">&nbsp;</div>
                        {researchData.map((data, i) => (
                            <button
                                key={i}
                                onClick={() => handleDataClick(i)}
                                className={`notActive ${isActive === i ? "active" : ""}`}
                            ></button>
                        ))}
                    </div>
                    <ResearchList
                        isActive={isActive}
                        handleDataClick={handleDataClick}
                    />
                </div>
            </div>
        </>
    );
}

function ImageWheel({ isActive }) {
    const { i18n } = useTranslation("researchTranslationContainer");
    const researchData = i18n.getResourceBundle(
        i18n.language,
        "researchTranslationContainer"
    ).researchTranslation;

    const nextImageActive = (isActive + 1) % 3;

    return (
        <>
            <div className="imageContainer">
                <img
                    className="primaryImage"
                    src={researchData[isActive].image}
                    alt="firstImage"
                />
                <img
                    className="secondaryImage"
                    src={researchData[nextImageActive].image}
                    alt="secondaryImage"
                />
            </div>
        </>
    );
}

function ResearchAdvantages() {
    const { t } = useTranslation();

    return (
        <div className="advantagesContainer">
            <div className="advantagesLeft">
                <div className="bigTitle">{t("AdvantagesOfResearchTitle")}</div>
                <div className="content">{t("AdvantagesOfResearch")}</div>
            </div>

            <div className="advantagesRight">
                <div className="advantages-flex-item">
                    <RiWechatLine size={50} className="advantages-icon" />
                    <div>
                        <div className="title">
                            {t("interdisciplinaryCollaborationTitle")}
                        </div>
                        <div className="content">
                            {t("interdisciplinaryCollaboration")}
                        </div>
                    </div>
                </div>
                <div className="advantages-flex-item">
                    <RiMacLine size={50} className="advantages-icon" />
                    <div>
                        <div className="title">
                            {t("AdvancedTechnologicalResourcesTitle")}
                        </div>
                        <div className="content">
                            {t("AdvancedTechnologicalResources")}
                        </div>
                    </div>
                </div>
                <div className="advantages-flex-item">
                    <RiCalendarTodoFill size={50} className="advantages-icon" />
                    <div>
                        <div className="title">
                            {t("ProfessionalDevelopmentTitle")}
                        </div>
                        <div className="content">
                            {t("ProfessionalDevelopment")}
                        </div>
                    </div>
                </div>
                <div className="advantages-flex-item">
                    <RiCommunityFill size={50} className="advantages-icon" />
                    <div>
                        <div className="title">{t("StrongIndustryTitle")}</div>
                        <div className="content">{t("StrongIndustry")}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ResearchMain() {
    const [isActive, setIsActive] = useState(0);

    const handleDataClick = (i) => {
        setIsActive(i);
    };

    return (
        <div className="mainContainer">
            <ResearchAdvantages />
            <div className="contentsContainer">
                <ImageWheel isActive={isActive} />
                <ResearchText
                    isActive={isActive}
                    handleDataClick={handleDataClick}
                />
            </div>
        </div>
    );
}

export default ResearchMain;
